import React, {useState, useEffect} from 'react';
import {useParams, useHistory} from 'react-router-dom';
import axios from 'axios';
import useNotif from 'hooks/use-notify-hook';
import {useAlert, TYPES} from 'hooks/use-alert-hook.js';
import {useLocalStorage, useDebounce} from 'react-use';
import AnswerActionContext from '../Utils/context.js';
import AnswerActionEdit from '../Edit.js';
import FileUpload from 'components/FileUpload/FileUpload.js';
import {
  Button,
  Col,
  Form,
  Row,
} from 'react-bootstrap';
import { ACTIONS } from 'views/Audit/Utils/action.js';

export default function Edit() {

  const history = useHistory();
  const {actionId, employeeId} = useParams();
  const [notif, dispatchNotif] = useNotif();
  const [swal, setSwal] = useAlert(null);
  const [auth] = useLocalStorage('authenticated');
  const [actionDescription, setActionDescription] = useState(null);
  const [hideSubmit, setHideSubmit] = useState(true);
  const [checkUpload, setCheckUpload] = useState(false);

  const [, cancelActionDescription] = useDebounce(async () => {

    try {

      const response = await axios.put(
        `${process.env.REACT_APP_API_HOST}answer-actions/${actionId}`,
        {ACTION_DESC: actionDescription},
        {headers: {Authorization: `Bearer ${auth.token}`}},
      );

      dispatchNotif({
        place: `br`,
        message: `Update Success...`,
        type: `success`,
      });

    } catch (error) {
      console.log(error);
      alert(`error`);
    }

  }, 2000, [actionDescription]);

  const handleDeleteAttachment = async (id, callback) => {

    try {

      const response = await axios.delete(
        `${process.env.REACT_APP_API_HOST}answer-action-attachments/${id}`,
        {headers: {Authorization: `Bearer ${auth.token}`}},
      );

      callback({
        type: ACTIONS.DELETE,
        payload: id,
      });

      dispatchNotif({
        place: `br`,
        message: `Delete Success...`,
        type: `success`,
      });

    } catch (error) {
      console.log(error);
      alert(`error`);
    }
  }

  const handleUpload = async (file, callback) => {

    try {

      const formData = new FormData();
      formData.append('document', file);

      const response = await axios.post(
        `${process.env.REACT_APP_API_HOST}answer-actions/${actionId}/upload`, formData,
        {hearders: {
          Authorization: `Bearer ${auth.token}`,
          'Content-Type': 'multipart/form-data'
        }}
      );

      callback({
        type: ACTIONS.CREATE,
        payload: response.data,
      })

      dispatchNotif({
        place: `br`,
        message: `Upload Success...`,
        type: `success`,
      });

    } catch (error) {
      dispatchNotif({
        place: `br`,
        message: `Upload Failed ${error.toString()}`,
        type: `danger`,
      });
    }
  }

  const handleSubmit = async (scheduleId) => {

    try {
      setCheckUpload(true)
      const onSuccessCallback = async () => {

        const response = await axios.put(
          `${process.env.REACT_APP_API_HOST}answer-actions/${actionId}`,
          {ANSWER_ACTION_STATUS: `IN PROGRESS`},
          {headers: {Authorization: `Bearer ${auth.token}`}},
        );

        history.push(`/auditee/${employeeId}/audits/${scheduleId}/findings`);

      }

      setSwal({
        type: TYPES.CONFIRM,
        payload: {
          title: `Are you sure!`,
          message: `You won't be able to edit it again.`,
          onSuccess: {
            title: `Success`,
            message: `Submit Success`,
            callback: onSuccessCallback,
          }
        }
      });

    } catch (error) {
      console.log(error);
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  useEffect(() => {
    cancelActionDescription();
  }, []);

  useEffect(() => {
    if(actionDescription || checkUpload){
      setHideSubmit(false)
    }else{
      setHideSubmit(true)
    }
  }, [actionDescription,checkUpload]);

  return (
    <AnswerActionEdit>
      {swal}{notif}
      <AnswerActionContext.Consumer>
        {({answerAction, dispatchAnswerAction, attachments, dispatchAttachments}) => (
          <Row>
            <Col md="8">
              <Form.Group>
                <Form.Label>{answerAction?.actionType?.ACTION_TYPE_NAME}</Form.Label>
                {answerAction?.ANSWER_ACTION_STATUS === 'OPEN'
                  ? (
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={actionDescription || answerAction.ACTION_DESC}
                      onChange={({target: {value}}) => setActionDescription(value)}
                      isInvalid={actionDescription?.length > 4000}
                    />
                  )
                  : <div style={{whiteSpace: 'pre-wrap'}} dangerouslySetInnerHTML={{__html: answerAction?.ACTION_DESC}} />
                }
                <Form.Text id="passwordHelpBlock" muted>
                  Total characters: {actionDescription?.length ?? 0}  / 4000
                </Form.Text>
              </Form.Group>
              {answerAction?.ANSWER_ACTION_STATUS === 'OPEN' && (
                <Form.Group>
                  <Button disabled={hideSubmit} variant="success" onClick={() => handleSubmit(answerAction?.answer?.form?.SCHEDULE_ID)}>Submit</Button>
                </Form.Group>
              )}
              {answerAction?.REJECT_EXPLAIN !== null && answerAction?.ANSWER_ACTION_STATUS === 'OPEN' && (
                <Form.Group>
                  <Form.Label>comments for rejection</Form.Label>
                  {answerAction?.REJECT_EXPLAIN ? (
                    <div
                      style={{ whiteSpace: 'pre-wrap' }}
                      dangerouslySetInnerHTML={{ __html: answerAction.REJECT_EXPLAIN }}
                    />
                  ) : (
                    <p>N/A</p>
                  )}
                </Form.Group>
              )}
            </Col>
            <Col md="4">
              <Form.Group>
                {attachments
                  ? attachments.map((attachment, key) => (
                    <div key={key} className="font-icon-detail">
                      <a href={`${process.env.REACT_APP_API_HOST}answer-action-attachments/${attachment.ANSWER_ACTION_ATTACHMENT_ID}/download`}>
                        {attachment.ATTACHMENT_NAME}.{attachment.ATTACHMENT_EXT}
                      </a>
                      {' '}
                      {answerAction?.ANSWER_ACTION_STATUS === 'OPEN' && (
                        <Button
                          variant="danger"
                          size="sm"
                          value={attachment.ANSWER_ACTION_ATTACHMENT_ID}
                          onClick={() => handleDeleteAttachment(attachment.ANSWER_ACTION_ATTACHMENT_ID, dispatchAttachments)}
                        >
                          <i className="nc-icon nc-simple-remove"></i>
                        </Button>
                      )}
                    </div>
                  ))
                  : <p>No file uploaded.</p>
                }
              </Form.Group>
              {answerAction?.ANSWER_ACTION_STATUS === 'OPEN' && (
                <FileUpload
                  onFileSelectSuccess={(file) => handleUpload(file, dispatchAttachments)}
                  onFileSelectError={({ error }) => alert(error)}
                >
                  Upload
                </FileUpload>
              )}
            </Col>
          </Row>
        )}
      </AnswerActionContext.Consumer>
    </AnswerActionEdit>
  )
}